export const ONLINE_MENU_SEARCH_DELAY = 300;

export const normalizeOnlineMenuSearch = (value) =>
  `${value ?? ""}`.trim().toLowerCase();

export const getOnlineMenuSearchErrorMessage = (error) =>
  error?.response?.data?.responseText ||
  error?.message ||
  "Không thể tìm kiếm sản phẩm. Vui lòng thử lại.";

export const createOnlineMenuSearchParams = ({
  store,
  categoryId = 0,
  search = "",
}) => ({
  store,
  categoryId,
  search: normalizeOnlineMenuSearch(search),
});
